import { desktop } from "@wordpress/icons";

const attributes = {
    id: {
        type: 'string',
        default: ''
    },
    state: {
        type: 'object',
        default: {
            openTab: 'setting',
            openSettingSection: 'settings',
            openStyleSection: 'layout',
            openBackgroundTab: 'classic'
        }
    },
    padding: {
        type: 'object',
        top: {
            type: 'string',
            default: ''
        },
        right: {
            type: 'string',
            default: ''
        },
        bottom: {
            type: 'string',
            default: ''
        },
        left: {
            type: 'string',
            default: ''
        }
    },
    margin: {
        type: 'object',
        top: {
            type: 'string',
            default: ''
        },
        right: {
            type: 'string',
            default: ''
        },
        bottom: {
            type: 'string',
            default: ''
        },
        left: {
            type: 'string',
            default: ''
        }
    },
    'background-color': {
        type: 'string',
        default: ''
    },
    border: {
        type: 'object',
        style: {
            type: 'string',
            default: ''
        },
        width: {
            top: {
                type: 'string',
                default: ''
            },
            right: {
                type: 'string',
                default: ''
            },
            bottom: {
                type: 'string',
                default: ''
            },
            left: {
                type: 'string',
                default: ''
            },
            isLinked: {
                type: 'number',
                default: 1
            },
            unit: {
                type: 'string',
                default: 'px'
            }
        },
        color: {
            type: 'string',
            default: ''
        },
        hoverColor: {
            type: 'string',
            default: ''
        },
        radius: {
            top: {
                type: 'string',
                default: ''
            },
            right: {
                type: 'string',
                default: ''
            },
            bottom: {
                type: 'string',
                default: ''
            },
            left: {
                type: 'string',
                default: ''
            },
            isLinked: {
                type: 'number',
                default: 1
            },
            unit: {
                type: 'string',
                default: 'px'
            }
        }
    },
    'button': {
        text: {
            type: 'string',
            default: ''
        },
        link: {
            type: 'string',
            default: ''
        },
        rel: {
            type: 'string',
            default: ''
        },
        'aria-label': {
            type: 'string',
            default: ''
        },
        target: {
            type: 'string',
            default: ''
        }
    },
    'div': {
        link: {
            type: 'string',
            default: ''
        },
        rel: {
            type: 'string',
            default: ''
        },
        'aria-label': {
            type: 'string',
            default: ''
        },
        target: {
            type: 'string',
            default: ''
        }
    },
    icon: {
        value: {
            type: 'object',
            default: {}
        },
        position: {
            type: 'string',
            default: ''
        },
        size: {
            type: 'string',
            default: ''
        },
        rotate: {
            type: 'string',
            default: ''
        },
        color: {
            type: 'string',
            default: ''
        },
        spacing: {
            type: 'string',
            default: ''
        }
    },
    typography: {
        color: {
            type: 'string',
            default: ''
        },
        'font-weight': {
            type: 'string',
            default: ''
        },
        'text-transform': {
            type: 'string',
            default: ''
        },
        'text-decoration': {
            type: 'string',
            default: ''
        },
        'font-size': {
            type: 'string',
            default: ''
        },
        'line-height': {
            type: 'string',
            default: ''
        },
        'letter-spacing': {
            type: 'string',
            default: ''
        },
        'text-align': {
            type: 'string',
            default: ''
        }
    },
    'background-image': {
        url: {
            type: 'string',
            default: ''
        },
        external_url: {
            type: 'string',
            default: ''
        },
        dynamic_url: {
            type: 'string',
            default: ''
        },
        'blend-mode': {
            type: 'string',
            default: ''
        },
        position: {
            type: 'string',
            default: ''
        },
        positionX: {
            type: 'string',
            default: ''
        },
        positionY: {
            type: 'string',
            default: ''
        },
        attachment: {
            type: 'string',
            default: ''
        },
        repeat: {
            type: 'string',
            default: ''
        },
        size: {
            type: 'string',
            default: ''
        },
        sizeCustom: {
            type: 'string',
            default: ''
        }
    },
    htmlTag: {
        type: 'string',
        default: 'div'
    },
    customTag: {
        type: 'string',
        default: 'div'
    },
    display: {
        type: 'string',
        default: ''
    },
    'flex-wrap': {
        type: 'string',
        default: ''
    },
    'flex-direction': {
        direction: {
            type: 'string',
            default: ''
        },
        isReverse: {
            type: 'boolean',
            default: false
        }
    },
    'align-self': {
        type: 'string',
        default: ''
    },
    'justify-content': {
        type: 'string',
        default: ''
    },
    'align-items': {
        type: 'string',
        default: ''
    },
    'column-gap': {
        type: 'string',
        default: ''
    },
    'row-gap': {
        type: 'string',
        default: ''
    },
    'flex-grow': {
        type: 'string',
        default: ''
    },
    'flex-shrink': {
        type: 'string',
        default: ''
    },
    'flex-basis': {
        type: 'string',
        default: ''
    },
    'order': {
        type: 'string',
        default: ''
    },
    'grid-gap': {
        type: 'string',
        default: ''
    },
    'grid-template-columns': {
        type: 'string',
        default: ''
    },
    'grid-template-rows': {
        type: 'string',
        default: ''
    },
    'grid-auto-rows': {
        type: 'string',
        default: ''
    },
    'grid-auto-flow': {
        type: 'string',
        default: ''
    },
    'justify-items': {
        type: 'string',
        default: ''
    },
    'align-content': {
        type: 'string',
        default: ''
    },
    width: {
        type: 'string',
        default: ''
    },
    'min-width': {
        type: 'string',
        default: ''
    },
    'max-width': {
        type: 'string',
        default: ''
    },
    'height': {
        type: 'string',
        default: ''
    },
    'min-height': {
        type: 'string',
        default: ''
    },
    'max-height': {
        type: 'string',
        default: ''
    },
    top: {
        type: 'string',
        default: ''
    },
    right: {
        type: 'string',
        default: ''
    },
    bottom: {
        type: 'string',
        default: ''
    },
    left: {
        type: 'string',
        default: ''
    },
    'z-index': {
        type: 'string',
        default: ''
    },
    position: {
        type: 'string',
        default: ''
    },
    visibility: {
        type: 'string',
        default: ''
    },
    overflow: {
        type: 'string',
        default: ''
    },
    opacity: {
        type: 'string',
        default: ''
    },
    cursor: {
        type: 'string',
        default: ''
    },
    isolation: {
        type: 'string',
        default: ''
    },
    'pointer-events': {
        type: 'string',
        default: ''
    },
    heading: {
        content: {
            type: 'string',
            default: 'I am a heading'
        },
        tag: {
            type: 'string',
            default: 'h2'
        }
    },
    css: {
        type: 'string',
        default: ''
    },
    cssCustom: {
        type: 'string',
        default: ''
    },
    customHTML: {
        htmlContent: {
            type: 'string',
            default: ''
        },
        parentTag: {
            type: 'string',
            default: ''
        },
        customTag: {
            type: 'string',
            default: ''
        }
    },
    'basic-text': {
        content: {
            type: 'string',
            default: ''
        },
        tag: {
            type: 'string',
            default: ''
        },
        customTag: {
            type: 'string',
            default: ''
        }
    },
    image: {
        id: {
            type: 'string',
            default: ''
        },
        src: {
            type: 'string',
            default: ''
        },
        dynamic_src: {
            type: 'string',
            default: ''
        },
        external_url: {
            type: 'string',
            default: ''
        },
        alt: {
            type: 'string',
            default: ''
        },
        title: {
            type: 'string',
            default: ''
        },
        width: {
            type: 'string',
            default: '100%'
        },
        height: {
            type: 'string',
            default: 'auto'
        },
        caption: {
            type: 'string',
            default: ''
        },
        'caption-alignment': {
            type: 'string',
            default: ''
        }
    },
    custom_attributes: {
        type: 'array',
        default: []
    }
}

export { attributes };